/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementLandingPagesAppGroupIdUpdateArchivedStateProps,
  EngagementLandingPagesAppGroupIdUpdateArchivedStateResult,
} from "./types";

export const postEngagementLandingPagesAppGroupIdUpdateArchivedState = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdUpdateArchivedStateCacheKeys,
  ({
    mark_as_archived,
    appGroupId,
    landingPageBsonIds,
  }: PostEngagementLandingPagesAppGroupIdUpdateArchivedStateProps): Promise<EngagementLandingPagesAppGroupIdUpdateArchivedStateResult> => {
    return fetch(
      `/engagement/landing_pages/${appGroupId}/update_archived_state`,
      "POST",
      {
        mark_as_archived,
        landing_page_bson_ids: landingPageBsonIds,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
